"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Months = void 0;
exports.Months = [
    {
        text: "january",
        number: "01",
    },
    {
        text: "fabruary",
        number: "02",
    },
    {
        text: "march",
        number: "03",
    },
    {
        text: "april",
        number: "04",
    },
    {
        text: "may",
        number: "05",
    },
    {
        text: "june",
        number: "06",
    },
    {
        text: "july",
        number: "07",
    },
    {
        text: "august",
        number: "08",
    },
    {
        text: "september",
        number: "09",
    },
    {
        text: "october",
        number: "10",
    },
    {
        text: "november",
        number: "11",
    },
    {
        text: "december",
        number: "12",
    },
];
//# sourceMappingURL=months.js.map